import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0f172a] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              Pringle <span className="text-[#d4af37]">Construction</span>
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Building excellence and crafting legacies for over 25 years. Your trusted partner for luxury construction.
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-[#d4af37] rounded-full flex items-center justify-center transition-colors duration-200"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-[#d4af37] rounded-full flex items-center justify-center transition-colors duration-200"
              >
                <Twitter size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-[#d4af37] rounded-full flex items-center justify-center transition-colors duration-200"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-[#d4af37] rounded-full flex items-center justify-center transition-colors duration-200"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('portfolio')}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li className="hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                Residential Construction
              </li>
              <li className="hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                Commercial Construction
              </li>
              <li className="hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                Project Management
              </li>
              <li className="hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                Design & Consultation
              </li>
              <li className="hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                Renovations & Remodeling
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Mail className="text-[#d4af37] mr-3 flex-shrink-0 mt-1" size={18} />
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start">
                <Phone className="text-[#d4af37] mr-3 flex-shrink-0 mt-1" size={18} />
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="hover:text-[#d4af37] transition-colors duration-200"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="text-[#d4af37] mr-3 flex-shrink-0 mt-1" size={18} />
                <span>
                  {contactInfo.address}<br />
                  {contactInfo.city}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} Pringle Construction LLC. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors duration-200">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-[#d4af37] transition-colors duration-200">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
